export const noDevicesWarning =
  "You have no active devices! You will need to open Spotify on one of your devices, and possibly start playing a track for this web player to recognize it."
